import { map } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Command } from '../../../core/model/command';
import { ICommandHandler } from '../../../core/service/command/command-handler-resolver.service';
import { NativeWindowService } from '../../../core/service/native-window.service';
import { tenantCommand } from '../../model/const/command';
import { Contact } from '../../model/contact';
import { ContactService } from '../data/contact.service';

@Injectable()
export class PrintGdprCommandHandler implements ICommandHandler {
  constructor(
    private _service: ContactService,
    private _nativeWindow: NativeWindowService
  ) {}

  canExecute(command: Command): boolean {
    return command.id === tenantCommand.printGDPR && command.context;
  }

  execute(command: Command): Observable<boolean> {
    return this._service.getGdpr(command.context.id).pipe(
      map(res => {
        if (res) {
          this._nativeWindow.openFile(res, `${(<Contact>command.context).name}.pdf`);
          return true;
        }
        return false;
      })
    );
  }
}
